import {
  PlanCollection,
  PlanSelectionCacheStrategy
} from "@/property/shared/models/PlanCollection";
import { Property } from "@/property/shared/models/Property";

export class PropertyPlanSelectionReloader {
  public static async reloadForPropertyIds(propertyIds: number[]) {
    if (!propertyIds || propertyIds.length === 0) {
      return;
    }

    const planCollection = new PlanCollection();
    await planCollection.loadSelectionOfMultipleProperties(
      propertyIds.map(id =>
        Property.from({
          id
        })
      ),
      {
        cacheStrategy: PlanSelectionCacheStrategy.OnlyNetwork,
        onlyOffline: true
      }
    );
  }
}
